<template>
    <!-- 人员列表 -->
    <vPersonList :postList="postList" v-if="flag"></vPersonList>
</template>
<script>
import vPersonList from '../../listComponent/jurisdiction/personListComponent.vue';
export default {
    name: 'personList',
    components: {
        vPersonList
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                code: true,
                name: true,
                status: true,
                id_number: true,
                mobile: true,
                main_hierarchy_rid: true,
                main_hierarchy_department_rid: true,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>